module.exports = __webpack_public_path__ + "static/media/PSLxTextBold.8bfae045.ttf";